import React, {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";
import Nav from "./nav";
import AdminNav from "./adminNav";
import {Collapse} from "bootstrap";

const Sidebar = ({getRoles}) => {
	const mobileMenu = useRef(null);
	const location = useLocation();
	let bsNav = null;

	useEffect(() => {
		if (mobileMenu.current !== null) {
			bsNav = new Collapse(mobileMenu.current, {
				toggle: false
			});
			bsNav.hide();
		}
	}, [location.pathname])

	return (
		<div className="sidebar collapse navbar-collapse" id="navbarSupportedContent" ref={mobileMenu}>
			<div className="sidebar-inner">
				{(getRoles.length > 0) &&
					<>
						<Nav getRoles={getRoles}/>
						<AdminNav getRoles={getRoles}/>
					</>
				}
			</div>
		</div>
	);
};

export default Sidebar;
